import React from "react";
import Column from "@amzn/meridian/esm/components/column";

import InfoCard, { INFO_CARD_VARIANT } from "../../../components/InfoCard";
import { FEEDBACK_PAGE } from "../../../constants";

/**
 * Help tab in the in-meeting Aims app
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Help = () => {
  return (
    <Column alignmentHorizontal="center" spacing="400" spacingInset="450 none none none">
      <InfoCard variant={INFO_CARD_VARIANT.FEEDBACK} page={FEEDBACK_PAGE.IN_MEETING_FEEDBACK_TAB} />
      <InfoCard variant={INFO_CARD_VARIANT.WIKI} />
      <InfoCard variant={INFO_CARD_VARIANT.POLICY} />
    </Column>
  );
};
export default Help;
